import styles from './W_CapsuleCreators.module.css';
import C_CapsuleUserAvatars from '@/components/C_Collections/C_CapsuleUserAvatars/C_CapsuleUserAvatars';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

export interface W_CapsuleCreatorsProps {
  avatars: string[];
  coauthors: number;
  isMyCapsule?: boolean;
  ownerName?: string;
  ownerId?: string;
}

const getCoauthorWord = (
  count: number,
  language: string,
  t: (key: string) => string
): string => {
  if (language === 'ru') {
    if (count === 1) {
      return t('capsuleCreators.coauthorOne');
    } else if (count < 5) {
      return t('capsuleCreators.coauthorFew');
    } else {
      return t('capsuleCreators.coauthorMany');
    }
  } else {
    return count === 1
      ? t('capsuleCreators.coauthorOne')
      : t('capsuleCreators.coauthorFew');
  }
};

const getCreatorsText = (
  isMyCapsule: boolean,
  coauthors: number,
  ownerName: string,
  language: string,
  t: (key: string) => string
) => {
  if (isMyCapsule) {
    if (coauthors > 0) {
      const coauthorWord = getCoauthorWord(coauthors, language, t);
      return t('capsuleCreators.youAndCoauthors')
        .replace('{count}', coauthors.toString())
        .replace('{coauthor}', coauthorWord);
    }
    return t('capsuleCreators.you');
  } else {
    if (ownerName) {
      if (coauthors > 0) {
        const coauthorWord = getCoauthorWord(coauthors, language, t);
        return t('capsuleCreators.ownerAndCoauthors')
          .replace('{owner}', ownerName)
          .replace('{count}', coauthors.toString())
          .replace('{coauthor}', coauthorWord);
      }
      return ownerName;
    }
    if (coauthors > 0) {
      const coauthorWord = getCoauthorWord(coauthors, language, t);
      return t('capsuleCreators.coauthorsOnly')
        .replace('{count}', coauthors.toString())
        .replace('{coauthor}', coauthorWord);
    }
    return t('capsulePost.unknownAuthor');
  }
};

export default function W_CapsuleCreators({
  avatars,
  coauthors,
  isMyCapsule = false,
  ownerName,
  ownerId,
}: W_CapsuleCreatorsProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  const creatorsText = getCreatorsText(
    isMyCapsule,
    coauthors,
    ownerName || '',
    language,
    t
  );

  return (
    <div className={styles.wrapper}>
      <C_CapsuleUserAvatars avatars={avatars} />
      <span className={cn(styles.text, 'text-p-7')}>{creatorsText}</span>
    </div>
  );
}
